import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import Dashboard from "./Dashboard/Dashboard";
import Login from "./Auth/Login/Login";
import Register from "./Auth/Register/Register";
import Quiz from "./Quiz/Quiz/Quiz";
import PersonalityQuiz from "./Quiz/Quiz/PersonalityQuiz.js";
import Results from "./Quiz/Results/Results";
import ResultsPersonality from "./Quiz/Results/ResultsPersonality";
import QuizNav from "./Quiz/QuizNav/QuizNav";
import Consent from "./Quiz/Consent/Consent";
import Feedback from "./Quiz/Feedback/Feedback";
import ForgotPassword from "./Auth/ForgotPassword/ForgotPassword";
import ResetPassword from "./Auth/ResetPassword/ResetPassword";
import AdminScoreHistory from "./Dashboard/AdminDashboard/ExternalAdminDashboard/AdminScoreHistory/AdminScoreHistory";
import AdminAllUserScores from "./Dashboard/AdminDashboard/ExternalAdminDashboard/AdminAllUserScores/AdminAllUserScores";
import GeminiChat from "./GeminiChat/GeminiChat";
import UserManagement from "./Dashboard/AdminDashboard/ExternalAdminDashboard/UserManagement/UserManagement";
import GeminiConsent from "./GeminiChat/GeminiConsent";

function GeminiChatWithConsent(props) {
  const navigate = useNavigate();
  useEffect(() => {
    const consentGiven = localStorage.getItem("geminiConsent");
    if (!consentGiven) {
      navigate("/gemini-consent");
    }
  }, [navigate]);
  return <GeminiChat {...props} />;
}

function App() {
  return (
    <div className="App">
      <header className="App-header"></header>
      <main>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/register" element={<Register />} />
          <Route path="/quiz-nav" element={<QuizNav />} />
          <Route path="/consent" element={<Consent />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/quiz/personality" element={<PersonalityQuiz />} />
          <Route path="/results" element={<Results />} />
          <Route path="/results-personality" element={<ResultsPersonality />} />
          <Route path="/gemini-consent" element={<GeminiConsent />} />
          <Route path="/gemini-chat" element={<GeminiChatWithConsent />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />

          <Route path="/admin/user-management" element={<UserManagement />} />

          <Route path="/admin/score-history" element={<AdminScoreHistory />} />
          <Route
            path="/admin/all-user-scores"
            element={<AdminAllUserScores />}
          />
        </Routes>
      </main>
    </div>
  );
}

export default App;
